export default __webpack_public_path__ + "static/media/volume.c5209fd8.svg";